import { Typography } from '@mui/material';
import { META } from 'common/constants';
import { FormCheckbox } from 'components/lib/FormCheckbox';
import { FormControl } from 'components/lib/FormControl';
import type { FormikProps } from 'formik';
import type { FC } from 'react';
import CheckboxSectionCard from './CheckboxSectionCard';
import type { IPaymentFormikValues } from './CheckoutForm';

interface AutopayEnrollmentProps {
  formik: FormikProps<IPaymentFormikValues>;
  isLoading: boolean;
}

const AutopayEnrollment: FC<AutopayEnrollmentProps> = ({ formik, isLoading }) => {
  return (
    <FormControl
      error={formik.touched.authorize_autopay && Boolean(formik.errors.authorize_autopay)}
      errorMessage={String(formik.errors.authorize_autopay)}
      sx={{
        display: 'flex',
        pt: 6,
        pb: 4,
      }}
    >
      <CheckboxSectionCard
        title="Autopay Enrollment"
        titleColor="copper"
        description={
          <>
            <strong>Note</strong>: For your convenience, you have been enrolled in automatic premium
            payments using your selected payment method. If you prefer to opt out of this service
            once your policy becomes active, please call us at {META.CONTACT_NUMBER}.
          </>
        }
      >
        <FormCheckbox
          id="authorize_autopay"
          data-test="authorize_autopay"
          name="authorize_autopay"
          checked={formik.values.authorize_autopay}
          onChange={formik.handleChange}
          disabled={isLoading}
          labelText={
            <Typography variant="body2">
              I authorize THREE to automatically debit this payment method for future payments when
              they become due.{'  '}I understand that a $10 late fee applies to each failed
              installment payment attempt resulting in payment received more than 5 days after due
              date.
            </Typography>
          }
        />
      </CheckboxSectionCard>
    </FormControl>
  );
};

export default AutopayEnrollment;
